import { render, staticRenderFns } from "./UnsavedChangesConfimer.vue?vue&type=template&id=67851606"
import script from "./UnsavedChangesConfimer.vue?vue&type=script&lang=ts"
export * from "./UnsavedChangesConfimer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports